var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJordan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_39160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0649 0.804688H0.501953V20.3827H34.0649V0.804688Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_39160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0649 0.804688H0.501953V20.3827H34.0649V0.804688Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_39160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0649 0.804688H0.501953V20.3827H34.0649V0.804688Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_39160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0649 7.33203H0.501953V13.855H34.0649V7.33203Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_39160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0649 0.804688H0.501953V20.3827H34.0649V0.804688Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_39160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0649 13.8545H0.501953V20.3815H34.0649V13.8545Z",
    fill: "#337B40"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_39160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0649 0.804688H0.501953V20.3827H34.0649V0.804688Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_39160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.501953 0.804688V20.3827L20.0779 10.5937L0.501953 0.804688Z",
    fill: "#BC0030"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_39160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0649 0.804688H0.501953V20.3827H34.0649V0.804688Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_39160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55258 9.19434L6.24756 9.96432L5.45657 9.72232L5.87057 10.4373L5.18457 10.9053L6.00357 11.0303L5.94257 11.8543L6.55258 11.2923L7.15756 11.8543L7.09558 11.0303L7.91156 10.9053L7.22958 10.4373L7.64258 9.72232L6.85257 9.96432L6.55258 9.19434Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJordan);
export default __webpack_public_path__ + "static/media/JORDAN.217c175e72fed536e403a4a69d11d437.svg";
export { ForwardRef as ReactComponent };